/** @format */

import {
	AppProductReviewState,
	InvalidResponse,
	ReviewFilter,
	cleanReviewFilters,
	selectReviewFilters,
	selectSelectedFeature
} from '@product-reviews/data-access';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HmfGlobalChipsComponent, HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'product-reviews-filter-chips',
	templateUrl: './review-filter-chips.component.html',
	styleUrl: './review-filter-chips.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, HmfGlobalChipsComponent, HmfTextLinkComponent]
})
export class ReviewFilterChipsComponent {
	private readonly store = inject(Store<AppProductReviewState>);

	isHighlyRatedReviewsEnabled = input(false);

	readonly clearFilter = output<ReviewFilter>();
	readonly clearAllFilters = output<void>();

	selectedFilters$ = this.store
		.select(selectReviewFilters)
		.pipe(map((filters) => (filters instanceof InvalidResponse ? [] : filters)));
	selectedProCon$ = this.store.select(selectSelectedFeature);

	clearOne(filter): void {
		this.clearFilter.emit(filter);
	}

	clearAll(event): void {
		event.preventDefault();
		this.clearAllFilters.emit();
		this.store.dispatch(cleanReviewFilters());
	}
}
